import token from 'styled-token';

/** @mixin fontFamilyMixin */
/**
 * Adds font-family style with the `fontFamily` prop.
 *
 * @example
 * import { fontFamilyMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${fontFamilyMixin}
 * `;
 *
 * <Component fontFamily="serif">My serif text</Component>
 *
 * @method
 * @param {object} props
 * @param {string} [props.fontFamily] - A key for the `fonts` object on the theme.
 * @param {object} props.theme - The styled-components theme object with a `fonts` object.
 * @return {CSSObject}
 */
export var fontFamilyMixin = function fontFamilyMixin(props) {
  var fontFamily = props.fontFamily;
  if (!fontFamily) {
    return '';
  }
  return token("fonts." + fontFamily, function (font) {
    if (font) {
      return "font-family: " + font + ";";
    }
    return '';
  })(props);
};